import React from "react";
import useLoadAccount from "./useLoadAccount";
import NewProduct from "./products/NewProduct";
import Loading from "./Loading";
import { Container, Row, Col } from "react-bootstrap";

const LoadAccount = () => {
  const { accountitems, loading } = useLoadAccount();

  if (loading) {
    return (
      <Container>
        <Row>
          <Col>
            <Loading />
          </Col>
        </Row>
      </Container>
    );
  } else {
    return <NewProduct records={accountitems} />;
  }

  // console.log("CodeDeploy form: ", formData);
  // console.log("Data Records: ", datarecords);
};

export default LoadAccount;
